module.exports = __webpack_public_path__ + "img/1f36c.51417d2.svg";